"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSnippet = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const user_snippet_styles_1 = require("@/components/common/avatar/domain/user-snippet.styles");
require("@/components/common/avatar/semantics/user-avatar");
require("@/components/common/tag/semantics/accent-tag");
require("@/components/common/text/semantics/paragraph");
require("@/components/common/text/text");
let UserSnippet = class UserSnippet extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.phone = '';
        this.email = '';
        this.description = '';
        this.avatarSrc = '';
        this.tagLabel = '';
    }
    render() {
        return (0, lit_1.html) `
      <mm-user-avatar
        size="80"
        name=${this.name}
        src=${(0, if_defined_js_1.ifDefined)(this.avatarSrc || undefined)}
      ></mm-user-avatar>
      ${this.renderTag()}
      <div class="detail">
        <mm-text as="h2" size="24">${this.name}</mm-text>
        ${this.renderDescription()}
        <mm-text size="12">${this.email}</mm-text>
        <mm-text size="12">${this.phone}</mm-text>
      </div>
    `;
    }
    renderTag() {
        if (!this.tagLabel)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-accent-tag>${this.tagLabel}</mm-accent-tag>
    `;
    }
    renderDescription() {
        if (!this.description)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-paragraph>${this.description}</mm-paragraph>
    `;
    }
};
UserSnippet.styles = [user_snippet_styles_1.userSnippetStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], UserSnippet.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], UserSnippet.prototype, "phone", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], UserSnippet.prototype, "email", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], UserSnippet.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'avatar-src' })
], UserSnippet.prototype, "avatarSrc", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'tag-label' })
], UserSnippet.prototype, "tagLabel", void 0);
UserSnippet = __decorate([
    (0, decorators_js_1.customElement)('mm-user-snippet')
], UserSnippet);
exports.UserSnippet = UserSnippet;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci1zbmlwcGV0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidXNlci1zbmlwcGV0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUErQztBQUMvQyxxREFBMkQ7QUFDM0QsZ0VBQXdEO0FBRXhELCtGQUF5RjtBQUN6Riw0REFBeUQ7QUFDekQsd0RBQXFEO0FBQ3JELHdEQUFxRDtBQUNyRCx5Q0FBc0M7QUFHL0IsSUFBTSxXQUFXLEdBQWpCLE1BQU0sV0FBWSxTQUFRLGdCQUFVO0lBQXBDOztRQUV1QixTQUFJLEdBQUcsRUFBRSxDQUFBO1FBQ1QsVUFBSyxHQUFHLEVBQUUsQ0FBQTtRQUNWLFVBQUssR0FBRyxFQUFFLENBQUE7UUFDVixnQkFBVyxHQUFHLEVBQUUsQ0FBQTtRQUNTLGNBQVMsR0FBRyxFQUFFLENBQUE7UUFDZixhQUFRLEdBQUcsRUFBRSxDQUFBO0lBa0NuRSxDQUFDO0lBaENDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7ZUFHQSxJQUFJLENBQUMsSUFBSTtjQUNWLElBQUEseUJBQVMsRUFBQyxJQUFJLENBQUMsU0FBUyxJQUFJLFNBQVMsQ0FBQzs7UUFFNUMsSUFBSSxDQUFDLFNBQVMsRUFBRTs7cUNBRWEsSUFBSSxDQUFDLElBQUk7VUFDcEMsSUFBSSxDQUFDLGlCQUFpQixFQUFFOzZCQUNMLElBQUksQ0FBQyxLQUFLOzZCQUNWLElBQUksQ0FBQyxLQUFLOztLQUVsQyxDQUFBO0lBQ0gsQ0FBQztJQUVPLFNBQVM7UUFDZixJQUFJLENBQUMsSUFBSSxDQUFDLFFBQVE7WUFBRSxPQUFPLGFBQU8sQ0FBQTtRQUVsQyxPQUFPLElBQUEsVUFBSSxFQUFBO3VCQUNRLElBQUksQ0FBQyxRQUFRO0tBQy9CLENBQUE7SUFDSCxDQUFDO0lBRU8saUJBQWlCO1FBQ3ZCLElBQUksQ0FBQyxJQUFJLENBQUMsV0FBVztZQUFFLE9BQU8sYUFBTyxDQUFBO1FBRXJDLE9BQU8sSUFBQSxVQUFJLEVBQUE7c0JBQ08sSUFBSSxDQUFDLFdBQVc7S0FDakMsQ0FBQTtJQUNILENBQUM7O0FBdkNNLGtCQUFNLEdBQUcsQ0FBQyx1Q0FBaUIsQ0FBQyxDQUFBO0FBQ1A7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3lDQUFVO0FBQ1Q7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzBDQUFXO0FBQ1Y7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzBDQUFXO0FBQ1Y7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO2dEQUFpQjtBQUNTO0lBQXBELElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLFlBQVksRUFBRSxDQUFDOzhDQUFlO0FBQ2Y7SUFBbkQsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsV0FBVyxFQUFFLENBQUM7NkNBQWM7QUFQdEQsV0FBVztJQUR2QixJQUFBLDZCQUFhLEVBQUMsaUJBQWlCLENBQUM7R0FDcEIsV0FBVyxDQXlDdkI7QUF6Q1ksa0NBQVcifQ==